import HoverState from '@engoo/react-hover-state';
import React from 'react';
import { ToggleState } from 'app/components/mixins/ToggleState';
import { createStyles } from 'app/utils/css';
import { LINK_COLOR, LINK_HOVER_COLOR } from 'app/constants/Colors';
import BaseButton from 'app/components/common/BaseButton';
import { T } from 'app/components/localization';

const Styles = createStyles({
  editContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  editButton: ({ isHovered }) => ({
    cursor: 'pointer',
    border: 'none',
    backgroundColor: 'transparent',
    color: isHovered ? LINK_HOVER_COLOR : LINK_COLOR,
    fontWeight: 600,
    fontSize: '1em',
  }),
});

interface IProps {
  collapsedChildren: React.ReactNode;
  editableChildren: React.ReactNode;
  editBtnAriaLabel: string;
}

/**
 * Stack several items in a row next to an edit button.
 * After clicking edit, it will show the editable components.
 * So you default it to look one way, and upon clicking edit, it will transition
 * to the editable view.
 */
export const DefaultedEditContainer: React.SFC<IProps> = (props) => (
  <T>{t =>
    <Styles>{ css =>
      <ToggleState>{({ setOpen, isOpen }) => (
        isOpen ? (
          props.editableChildren
        ) : (
          <div className={css('editContainer')}>
            {props.collapsedChildren}
            <HoverState>{(isHovered) =>
              <BaseButton
                type="button"
                aria-label={props.editBtnAriaLabel}
                className={css('editButton', { isHovered })}
                onClick={setOpen}
              >
                {t('forms.edit-button')}
              </BaseButton>
            }</HoverState>
          </div>
      ))}</ToggleState>
    }</Styles>
  }</T>
);

export default DefaultedEditContainer;
